var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 280,
    viewBox: "0 0 208 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.51 232.996C169.901 151.563 96.0731 116.237 96.0731 116.237L65.3201 132.124C64.2377 132.124 71.0843 161.296 71.0843 161.296L116.64 181.476L158.824 246.714L190.916 235.623L182.51 232.996Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.204 131.025C110.652 126.873 101.099 125.228 91.6508 126.28C82.2027 127.332 73.2455 131.037 65.8159 136.968C67.321 145.26 71.0844 161.296 71.0844 161.296L116.64 181.476L134.851 209.639C142.165 201.387 146.565 190.961 147.375 179.964C148.184 168.967 145.358 158.009 139.331 148.775C133.063 142.377 126.336 136.444 119.204 131.025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.802 163.701C141.322 122.055 91.657 115.388 91.657 115.388L34.1807 101.261C34.1807 101.261 24.7017 164.051 97.2056 165.102L62.9188 232.996L94.4316 246.714L91.657 237.199C91.657 237.199 143.686 188.57 142.802 163.701Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1807 101.261C34.1807 101.261 24.7016 164.051 97.2056 165.102L62.9188 232.996",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M34.1812 60.6887V101.261L91.6574 115.388V70.2012C91.6574 62.4155 89.0469 54.8546 84.2433 48.7274C79.4397 42.6002 72.7204 38.2605 65.1597 36.4023H65.1596C61.477 35.4971 57.6368 35.4413 53.9294 36.2391C50.2221 37.0368 46.7447 38.6672 43.7603 41.0069C40.7759 43.3466 38.3626 46.3343 36.7031 49.7441C35.0435 53.1539 34.1812 56.8965 34.1812 60.6887L34.1812 60.6887Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1313 14.2659V20.7395C51.1313 23.1719 51.9469 25.534 53.4476 27.4483C54.9483 29.3625 57.0476 30.7183 59.4096 31.2989L69.7113 33.8308V8.52025L61.1456 6.41493C59.9551 6.12234 58.7137 6.1043 57.5153 6.36218C56.3168 6.62006 55.1927 7.1471 54.2279 7.90344C53.2632 8.65979 52.4831 9.62562 51.9466 10.7279C51.4101 11.8301 51.1313 13.04 51.1313 14.2659V14.2659Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1313 20.7395C51.1313 23.1719 51.9469 25.534 53.4476 27.4483C54.9483 29.3625 57.0476 30.7183 59.4096 31.2988L69.7113 33.8308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6267 19.455C61.901 19.455 62.1235 19.2326 62.1235 18.9582C62.1235 18.6838 61.901 18.4614 61.6267 18.4614C61.3523 18.4614 61.1299 18.6838 61.1299 18.9582C61.1299 19.2326 61.3523 19.455 61.6267 19.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9968 19.455C54.2711 19.455 54.4936 19.2326 54.4936 18.9582C54.4936 18.6838 54.2711 18.4614 53.9968 18.4614C53.7224 18.4614 53.5 18.6838 53.5 18.9582C53.5 19.2326 53.7224 19.455 53.9968 19.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2353 21.9218V14.266H52.3999",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5629 14.2659H58.7275",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4873 18.1885V20.8472C69.176 20.8472 69.8365 20.5736 70.3235 20.0866C70.8104 19.5996 71.084 18.9392 71.084 18.2505C71.084 18.1708 71.0805 18.092 71.0734 18.0141C70.9279 16.4016 68.4873 16.5695 68.4873 18.1885Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4878 20.8472C69.1765 20.8472 69.837 20.5736 70.324 20.0866C70.8109 19.5997 71.0845 18.9392 71.0845 18.2505",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3325 22.8163C58.4922 22.976 58.6817 23.1026 58.8904 23.189C59.099 23.2754 59.3226 23.3199 59.5484 23.3199C59.7742 23.3199 59.9978 23.2754 60.2064 23.189C60.415 23.1026 60.6045 22.976 60.7642 22.8163",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2354 21.9279L57.9128 22.3402",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7383 17.1724C50.7383 17.1724 55.3588 14.7663 56.1413 10.6968C56.1461 10.6665 56.161 10.6387 56.1835 10.6179C56.2061 10.5971 56.235 10.5845 56.2656 10.5822C56.2962 10.5798 56.3266 10.5879 56.3521 10.605C56.3775 10.6222 56.3965 10.6474 56.4058 10.6766C56.9731 12.4406 59.3224 17.0795 68.488 18.1886",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1316 19.5489C51.1316 19.5489 46.535 17.5226 47.3522 12.1518C48.1695 6.78105 63.9316 -7.85316 74.5563 6.17739C85.1811 20.2079 102.753 46.7115 102.753 46.7115L91.1579 48.4938C88.505 48.9016 85.7952 48.7309 83.2145 47.9935C80.6337 47.2561 78.2428 45.9694 76.2058 44.2216C74.1688 42.4738 72.5338 40.3062 71.4129 37.8674C70.292 35.4286 69.7116 32.7763 69.7116 30.0922V22.8163",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.415 91.5065H109.96L116.233 36.6425H207.688L201.415 91.5065Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.783 86.8266H106.329L112.602 31.9625H204.056L197.783 86.8266Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.313 107.627L160.691 86.8267H146.065L143.687 107.627H158.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.228 107.627H205.377",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9401 42.4718C41.9401 42.4718 18.2486 61.9281 12.294 93.3745C6.3395 124.821 53.554 117.265 76.0426 108.008",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3384 91.5064C37.3384 91.5064 90.7541 82.0645 94.4319 105.457",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.772 42.4718C77.772 42.4718 94.5354 59.7698 98.9563 91.5065C98.9563 91.5065 115.96 92.0913 116.64 105.457",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0504 52.723C32.0504 52.723 24.4317 36.904 18.1269 50.5645C11.8221 64.2249 -15.7272 154.243 13.345 169.305C42.4171 184.366 84.9296 176.094 84.9296 176.094",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8016 178.361V279.737H18.127",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople1);
export default __webpack_public_path__ + "static/media/people-1.f2174713400415ce29325a44351e79c1.svg";
export { ForwardRef as ReactComponent };